import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../../services/context/authContext/AuthContext";

const PrivateRoute = ({ element: Component, ...rest }) => {
  const user = useContext(AuthContext);

  if (!!user) {
    return <Component />;
  } else {
    return <Navigate to={"/login"} />;
  }
};

export default PrivateRoute;
